/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unknown-property */
/* eslint-disable react/sort-comp */
import React, { Component, Fragment, useContext } from "react";
import _ from "lodash";
import moment from "moment";
import { Col, Row, Icon, Spin, Button, FormItem, Select, Popconfirm, Input, TextArea, Checkbox } from "../../common/UIComponents";
import {
  isEmpty,
  checkNegitive,
  findTotal,
  alertMessage,
  doFormate,
  base64ToPdf,
} from "../../common/Common";
import I18n from "../../common/I18n";
import AppConfig from "../../config/AppConfig";
import { fetchOrganizationDetails } from "../../api/Organisations";
import EditEstimateModal from "../../stories/components/EditEstimateModal";
import PrepaidAmountWithPreview from "./PrepaidAmountWithPreview";

import {
  invoiceHeading,
  mainHeading,
  shipperHeading,
  invoiceItem,
  totalItems,
  marginTop40,
  marginTop20,
  textBold,
  marginTop10,
  fontSize10,
  paddingTop20,
  smallContent,
  commentSection,
  borderLine,
  heading,
  alignCenter,
  alignRight,
  padding5,
  borderCollapseInherit,
  marginLeft10,
  floatLeft,
} from "../../helpers/invoice_styles";
import AddressInfo from "../common/AddressInfo";
import logo from "../../../assets/images/logo-thumbnail.png";
import userStore from "../../stores/UserStore";
import {
  fetchQuotationDetails,
  getContactEmails,
  printQuoteOrdersPdf,
  saveInvoice,
} from "../../api/Billing";
import { checkServiceExistance, formatUSPhoneNumber, renderAlertMessage } from "../../helpers/common";
import HawbMawbNo from "./HawbMawbNo";
import { findSpanValue, isInvoiceLocked } from "../../helpers/billing";
import BranchesIcon from "../common/BranchesIcon";
import BaseModal from "../BaseModal";
import { validateEmailList } from "../billing_screen/helpers";
import { OrgContext } from "../../context/OrgContext";
import { withRouter } from "react-router-dom";
import { sendEmailsForEstimateBilling } from "../../api/OrdersApi";
import RegenerationalConfirmationModal from "../../common/RegenerationalConfirmationModal";
import ManageInvoiceLine from "./ManageInvoiceLine";
import { SendEmailIcon, PrintEstimateIcon, PickupIconEstimate, DeliveryIconEstimate } from "../../common/CustomIcon";
import Button_v2 from "../../stories/components/Button_v2";

class FormComponent extends Component {
  constructor(props) {
    PrintEstimateIcon
    super(props);
    this.state = {
      account: this.props.account ? this.props.account : {},
      invoice: !isEmpty(this.props.currentInvoice)
        ? this.props.currentInvoice
        : {
          account_details: {},
          warehouse_details: {},
          driver_details: {},
          order_info: {},
        },
      logo,
      chargeTypes: [
        "transportation_charges",
        "fuel_surcharges",
        "accessorial_charges",
        "adjustment_charges",
      ],
      callInvoceDetails: this.props.callInvoceDetails
        ? this.props.callInvoceDetails
        : false,
      order_id: this.props.order_id,
      showHeading:
        this.props.showHeading === false ? this.props.showHeading : true,
      showOtherDetails:
        this.props.showOtherDetails === false
          ? this.props.showOtherDetails
          : true,
      inProgress: false,
      order_references: {},
      printProgress: false,
      showEmailModal: false,
      isLoadingEmailData: false,
      listOfEmails: [],
      contactsData: [],
      subject: '',
      description: '',
      orgSettings: props.organizationSettings,
      isSendingEmailData: false,
      activeKey: '',
      currentOrderGroupType: this.props.currentOrderGroupType || "",
      dataToEdit: null,
      disableRecalculate: false,
      isEstimateModalVisible: false,
      estimateData: {
        PICKUP: { distance: 0, amount: 0, location_id: "" },
        DELIVERY: { distance: 0, amount: 0, location_id: "" },
      },
      dataSource: [
        { key: '1', stop: 'PICKUP', distance: 0, rate: 0, includesFuel: false },
        { key: '2', stop: 'DELIVERY', distance: 0, rate: 0, includesFuel: false },
      ],
    };
  }

  componentDidMount() {
    this.getOrgLogo();
    this.setInvoiceDetails();
  }

  componentDidUpdate(prevState, prevProps) {
    const {customer_order_details} = this.props.order || {};
    const isLocked = isInvoiceLocked(customer_order_details);
    if (this.props.activeKey !== this.state.activeKey) {
      this.setState({
        activeKey: this.props.activeKey
      }, () => {
        if (this.props.activeKey == "billing") {
          if (isLocked) {
            // Invoice is locked, only fetch billing details
            this.getBillingDetails();
          } else {
            // Invoice is not locked, generate quotation
            this.handleGenerateQuotation(this.state.order_id);
          }
        }
      })
    }
  }

  showEstimateModal = () => {
    const { order } = this.props;
    const LocationIds = order?.locations || [];
    const transportationCharges = order?.order_quotations || [];
  
    const { pickupRate, deliveryRate , pickupIncludesFuel, deliveryIncludesFuel } =
      transportationCharges.reduce(
        (acc, loc) => {
          
          if (loc.type_of_loc === "PICKUP"){ acc.pickupRate = loc.amount || 0; acc.pickupIncludesFuel = loc.configurations?.include_fuel_surcharge === "true";}
          if (loc.type_of_loc === "DELIVERY") {acc.deliveryRate = loc.amount || 0; acc.deliveryIncludesFuel = loc.configurations?.include_fuel_surcharge === "true";}
          return acc;
        },
        { pickupRate: 0, deliveryRate: 0, pickupIncludesFuel: false, deliveryIncludesFuel: false }
      );
  
    const locationData = LocationIds.reduce(
      (acc, loc) => {
        if (loc.type_of_loc === "PICKUP") acc.pickupLocationId = loc.location_id;
        if (loc.type_of_loc === "DELIVERY") acc.deliveryLocationId = loc.location_id;
        return acc;
      },
      { pickupLocationId: null, deliveryLocationId: null }
    );
  
    let estimateData = [];
  
    if (locationData.pickupLocationId && locationData.deliveryLocationId) {
      estimateData = [
        { key: "1", stop: "Pickup", distance: 0, amount: pickupRate, includesFuel: pickupIncludesFuel, location_id: locationData.pickupLocationId },
        { key: "2", stop: "Delivery", distance: 0, amount: deliveryRate, includesFuel: deliveryIncludesFuel , location_id: locationData.deliveryLocationId }
      ];
    } else if (["R", "TR"].includes(order.type_of_order) || locationData.pickupLocationId) {
      estimateData.push({ key: "1", stop: "Pickup", distance: 0, amount: pickupRate, includesFuel: pickupIncludesFuel , location_id: locationData.pickupLocationId });
    } else if (["D", "TD"].includes(order.type_of_order) || locationData.deliveryLocationId) {
      estimateData.push({ key: "2", stop: "Delivery", distance: 0, amount: deliveryRate, includesFuel: deliveryIncludesFuel, location_id: locationData.deliveryLocationId });
    }
  
    this.setState({ 
      isEstimateModalVisible: true, 
      estimateData,
      dataSource: estimateData 
    });
  };
  
  
  handleEstimateModalCancel = () => {
    this.setState({ isEstimateModalVisible: false });
  };

  handleEstimateModalOk = () => {
    const { dataSource } = this.state;
    const order_id = this.state.order_id;
    const payload = {
      order_id,
      is_for_invoice_quote:true,
      transportation_charges: dataSource.map(item => ({
        order_id: order_id,
        price_list: [
          {
            invoice_name: "Transportation Charges",
            invoice_value: item.rate,
            
          },
        ],
      })),
    };
    saveInvoice(payload)
      .then(result => {
        if (result.success) {
          alertMessage(I18n.t("messages.invoice_updated"));
          this.setState({
            isEstimateModalVisible: false,
            callInvoceDetails: true,
          });
        } else if (result.errors) {
          renderAlertMessage(result.errors);
        }
      });
  };

  handleTableChange = (value, key, columnKey) => {
    const newData = this.state.dataSource.map((item) => {
      if (item.key === key) { // Use `key` for comparison
        return { ...item, [columnKey]: value };
      }
      return item;
    });
    this.setState({ dataSource: newData });
  };

  calculateTotals = () => {
    let totalDistance = 0;
    let totalRate = 0;

    this.state.dataSource.forEach((item) => {
      totalDistance += parseFloat(item.distance) || 0;
      totalRate += parseFloat(item.rate) || 0;
    });

    return {
      totalDistance: totalDistance.toFixed(2),
      totalRate: totalRate.toFixed(2),
    };
  };

  getZoneType = (key) => {
    const config = AppConfig.billingZones.find(
      (item) => item.key === key
    );
    return config ? config.lable : "";
  }
 
  setInvoiceDetails = (callInvoceDetails = true) => {
    if (
      this.state.callInvoceDetails === true &&
      checkServiceExistance("OQIND")
    ) {
    } else {
      this.setUpdateRefs();
    }
  };

  getBillingDetails = () => {
    const isLocked = isInvoiceLocked(this.props.order?.customer_order_details);
    this.setState({ inProgress: true });
    const isForQuote = false;
    return fetchQuotationDetails(this.state.order_id).then((result) => {
      if (result.success) {
        const invoice = result?.invoice ? result.invoice : {};
        invoice.is_for_invoice_quote = isForQuote;
        this.setState(
          {
            invoice,
            inProgress: false,
          },
          () => {
            this.setUpdateRefs();
            if (!isLocked) {
              setTimeout(() => {
                alertMessage(I18n.t("messages.quote_generated"));
              }, 1500);
            }
          }
        );
        // Only call updateQuote (which triggers fetchBillAmount_v2) after fetchQuotationDetails completes successfully
        if (this.props.updateQuote && !isLocked) {
          this.props.updateQuote(this.state.order_id, invoice.total_amount);
        }
        return result;
      } else if (result.errors) {
        renderAlertMessage(result.errors);
        this.setState({ inProgress: false });
        return result;
      }
    });
  };

  getContacts = () => {
    const account = _.get(this.state, "invoice.account_details", {});
    const accId = _.get(account, "id", "");
    this.setState({ isLoadingEmailData: true });
    getContactEmails(accId).then((result) => {
      if (result.success) {
        this.setState({ contactsData: result.contact_emails || [] });
      } else if (result.errors) {
        renderAlertMessage(result.errors)
        this.setState({ isLoadingEmailData: false });
      }
    }).finally(() => {
      this.setState({ isLoadingEmailData: false });
    });
  };

  setUpdateRefs = () => {
    const { invoice, order_references } = this.state;
    if (
      invoice?.transportation_charges &&
      invoice.transportation_charges.length > 0
    ) {
      invoice.transportation_charges.map((order) => {
        order_references[order.order_number] = {};
        order_references[order.order_number].hawb = order.hawb; // doFormate(order.hawb);
        order_references[order.order_number].mawb = order.mawb;
      });
      this.setState({
        order_references,
      });
    }
  };

  handleGenerateQuotation = (id, isRecalculate) => {
    this.setState({ inProgress: true, disableRecalculate: true });
    const isForQuote = false;
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];
    saveInvoice({ order_id: id, is_for_invoice_quote: "true", current_date: formattedDate }).then(
      (result) => {
        if (result.success) {
          // Wait for getBillingDetails (which calls fetchQuotationDetails) to complete
          // before allowing fetchBillAmount_v2 to be called
          this.getBillingDetails().then(() => {
            const invoice =
              !isEmpty(result.invoice) && _.isObject(result.invoice)
                ? result.invoice
                : {};
            invoice.is_for_invoice_quote = isForQuote;
            this.setState({
              //  invoice,
              inProgress: false,
              disableRecalculate: false
            });
          }).catch(() => {
            this.setState({ inProgress: false, disableRecalculate: false });
          });
        } else if (result.errors) {
          if(!isRecalculate){
            this.getBillingDetails();
          }
          renderAlertMessage(result.errors)
          this.setState({ inProgress: false, disableRecalculate: false });
        }
      }
    );
  };

  handleUpdateAmount = (result) => {
    const isForQuote = false;
    if (result.success) {
      // Wait for getBillingDetails (which calls fetchQuotationDetails) to complete
      // before allowing fetchBillAmount_v2 to be called
      this.getBillingDetails().then(() => {
        const invoice =
          !isEmpty(result.invoice) && _.isObject(result.invoice)
            ? result.invoice
            : {};
        invoice.is_for_invoice_quote = isForQuote;
        if (this.props.updateQuote) {
          this.props.updateQuote(this.state.order_id, invoice.total_amount);
        }
      });
    } else if (result.errors) {
      renderAlertMessage(result.errors)
    }
  }

  handlePrintBills = async (id) => {
    // const selectedIds = !isEmpty(orderIds) ? orderIds : [];
    this.setState({ printProgress: true });
    try {
      let result = await printQuoteOrdersPdf(id);
      if (result.success) {
        base64ToPdf(
          result.quote_orders_pdf,
          `BillingEstimates-${moment().format("YYYY-MM-DDTHH:mm:ss")}.pdf`
        );
      } else {
        if (result.errors.length > 0) {
          alertMessage(result.errors.join(", "), "error", 10);
        }
      }
    } catch (error) {
      alertMessage(error.message, "error", 10);
    } finally {
      this.setState({ printProgress: false });
    }
  };

  getOrgLogo = () => {
    const orgId = userStore.getStateValue("selectedOrg");
    fetchOrganizationDetails(orgId).then((result) => {
      if (result.success) {
        const organization = result.organization || {};
        organization.logo =
          !isEmpty(organization.logo) && organization.logo.url
            ? organization.logo.url
            : "";

        if (organization.logo) {
          this.setState({
            logo: organization.logo,
          });
        } else if (!isEmpty(orgId)) {
          const urlToFile = `${AppConfig.baseUrl}/org_logos/${orgId}/org_logo.png`;
          fetch(urlToFile).then((response) => {
            if (response.status === 200) {
              this.setState({
                logo: urlToFile,
              });
            }
          });
        }
      }
    });
  };

  handleSubmit = () => {
    const { currentOrg } = this.props
    const payload = {
      organization_id: _.get(currentOrg, "id", ""),
      customer_order_ids: this.props.order_id,
      email_ids: this.state.listOfEmails,
      subject: this.state.subject,
      description: this.state.description,
    };
    this.setState({ isSendingEmailData: true });
    sendEmailsForEstimateBilling(payload)
      .then((result) => {
        if (result.success) {
          alertMessage(result.data.message, "success");
          this.setState({ showEmailModal: false });
        } else if (result.errors) {
          renderAlertMessage(result.errors);
        }
      })
      .finally(() => {
        this.setState({ isSendingEmailData: false });
      });
  };


  handleCancel = () => {
    this.setState({ showEmailModal: false, listOfEmails: [] });
  }

  handleAddingEmails = (emails) => {
    const validatedEmails = validateEmailList(emails);
    this.setState({ listOfEmails: validatedEmails });
  }

  showEmailModal = () => {
    const { orgSettings } = this.state;
    const { invoice_body_text } = orgSettings;
    this.setState({
      showEmailModal: true,
      subject: `Estimate For ${_.get(this.state, "invoice.order_number", "")}`,
      description: invoice_body_text || I18n.t('configurations.default_email_body_message')
    });
    this.getContacts();
  }

  findSectionTotal = (sectionType) => {
    const { invoice } = this.state;
    const charges = [...invoice[sectionType]];
    const priceList =
      !isEmpty(charges) && charges.length > 0
        ? charges.map((order) => order.price_list)
        : [];
    const flattenList = _.flatten(priceList);
    const amount = findTotal(flattenList, "invoice_value", 1, true);
    return amount || 0.0;
  };

  renderTermsNConditions = () => (
    <div style={{ ...marginTop40, ...borderLine }}>
      <Row>
        <Col xs={24} className="heading">
          {I18n.t("invoices.termsNconditions")}
        </Col>
      </Row>
      {AppConfig.termsList.map((term, index) => (
        <p className="paddingLeft5">
          {index + 1}. {term}
        </p>
      ))}
    </div>
  );

  renderComments = () => (
    <div style={{ ...marginTop40, ...borderLine }}>
      <div style={{ ...heading }}>{I18n.t("invoices.comments")}</div>
      <div style={{ ...commentSection }} />
    </div>
  );

  renderEmailModal = () => {
    return (
      <BaseModal
        title={I18n.t("general.send_email")}
        onCancel={this.handleCancel}
        visible={this.state.showEmailModal}
        width="50%"
        maskClosable={false}
      >
        <Spin spinning={this.state.isLoadingEmailData} delay={1000}>
          <Row className="tagsInput emailForm" type="flex" align="middle" gutter={8}>
            <Col xs={21}>
              <FormItem label={I18n.t("general.emails")}>
                <Select
                  data-testid="emails-dropdown"
                  value={this.state.listOfEmails}
                  mode="tags"
                  onChange={this.handleAddingEmails}
                  style={{ width: "100%" }}
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  tokenSeparators={[","]}
                >
                  {this.state.contactsData?.map((contact) => (
                    <Select.Option key={contact}>
                      {contact}
                    </Select.Option>
                  ))}
                </Select>
              </FormItem>
            </Col>
            <Col xs={3}>

              <Button
                data-testid="send-invoice-button"
                onClick={() => this.handleSubmit()}
                type="primary"
                loading={this.state.isSendingEmailData}
                icon="mail"
                style={{ backgroundColor: "#607AD6", color: "#fff" }}
                size="small"
              >
                Send
              </Button>

            </Col>
          </Row>
          <Row>
            <Col>
              <FormItem label={"Subject"}>
                <Input
                  data-testid="subject-input"
                  rows={4}
                  placeholder={"Subject"}
                  className="sop-form-textArea"
                  value={this.state.subject}
                  onChange={(e) => this.setState({ subject: e.target.value })}
                />
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormItem label={"Description"}>
                <TextArea
                  data-testid="description-input"
                  rows={4}
                  placeholder={"Description"}
                  className="sop-form-textArea"
                  value={this.state.description}
                  onChange={(e) => this.setState({ description: e.target.value })}
                />
              </FormItem>
            </Col>
          </Row>
        </Spin>
      </BaseModal>
    );
  };

  renderWHDetails = () => {
    const whDetails = this.state.invoice.warehouse_details || {};
    return (
      <table width="100%">
        <tbody>
          <tr>
            <td>
              <img src={this.state.logo} alt="" style={{ maxWidth: "10rem" }} />
            </td>
          </tr>
          <tr>
            <td width="65%">
              <h2 style={{ ...mainHeading, ...textBold }}>{whDetails.name}</h2>
            </td>
            <td width="35%">
              <h2 style={{ ...alignCenter, ...invoiceHeading, ...textBold }}>
                INVOICE
              </h2>
            </td>
          </tr>
          <tr>
            <td width="65%" style={{ ...smallContent }}>
              <table width="100%" style={{ ...marginTop10 }} cellpadding="0px">
                <tbody>
                  <tr>
                    <td style={{ ...smallContent }}>
                      <AddressInfo
                        address={(whDetails && whDetails.address) || {}}
                        showIcon
                        displayType="line"
                      />
                    </td>
                  </tr>
                  {!isEmpty(whDetails.email) && (
                    <tr>
                      <td>
                        <Icon type="mail" /> &nbsp; {whDetails.email}
                      </td>
                    </tr>
                  )}
                  {!isEmpty(whDetails.contact) && (
                    <tr>
                      <td>
                        <Icon type="phone" /> &nbsp;{" "}
                        {formatUSPhoneNumber(whDetails.contact)}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </td>
            <td width="35%" style={{ ...smallContent }}>
              <table cellpadding="2px" cellspacing="0px" width="100%">
                <tbody>
                  <tr>
                    <td width="46%">{I18n.t("order.order_no")}</td>
                    <td width="4%">:</td>
                    <td width="50%">#{this.state.invoice.order_number} </td>
                  </tr>
                  <tr>
                    <td>{I18n.t("general.date")}</td>
                    <td>:</td>
                    <td>
                      {moment(this.state.invoice.date).format("MMM Do YYYY")}{" "}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  renderShipperDetails = () => {
    const data = this.state.invoice.account_details || {};
    const { billing_address, address } = data;
    const order_info = _.get(this.state.invoice, "order_info", {});
    return this.state.invoice.order_group_type !== "MANUAL" ? (
      <table width="100%" style={{ ...marginTop10 }} cellpadding="0px">
        <tbody>
          <tr>
            <td width="65%">
              <table width="100%">
                <tbody>
                  <tr>
                    <td style={{ ...shipperHeading, ...textBold }}>
                      <h3>{I18n.t("invoices.billed_to")}</h3>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ ...smallContent }}>
                      <h4>{data.name || "NA"}</h4>
                      <AddressInfo
                        // address={(data && data.address) || {}}
                        address={
                          !isEmpty(billing_address)
                            ? billing_address
                            : !isEmpty(address)
                              ? address
                              : "NA" || {}
                        }
                        showIcon
                        displayType="line"
                      />
                    </td>
                  </tr>
                  {!isEmpty(data.email) && (
                    <tr>
                      <td>
                        <Icon type="mail" /> &nbsp; {data.email}
                      </td>
                    </tr>
                  )}
                  {!isEmpty(data.contact) && (
                    <tr>
                      <td>
                        <Icon type="phone" /> &nbsp;{" "}
                        {formatUSPhoneNumber(data.contact)}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </td>
            <td width="35%">
              <table>
                <tbody>
                  {/* <tr>
                  <td>{I18n.t('order.weight')}</td><td>:</td><td>{this.state.invoice.order_info.order_weight ? `${this.state.invoice.order_info.order_weight} ${AppConfig.weight_unit}` : 'NA'}</td>
                </tr> */}
                  <tr>
                    <td>{I18n.t("general.Driver")}</td>
                    <td>:</td>
                    <td>
                      {this.state.invoice.driver_details
                        ? this.state.invoice.driver_details.code ||
                        this.state.invoice.driver_details.name ||
                        "NA"
                        : "NA"}
                    </td>
                  </tr>
                  <tr>
                    <td>{I18n.t("zones.zonename")}</td>
                    <td>:</td>
                    <td>
                      {order_info.zone_name || "NA"}
                      {order_info.fallback_note && (
                        <div className="notes_content">{order_info.fallback_note}</div>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>{I18n.t("zones.type")}</td>
                    <td>:</td>
                    <td>{order_info.zone_type || "NA"}</td>
                  </tr>
                  {order_info.zone_type === "location" && (
                    <tr>
                      <td>{I18n.t("general.zipcode")}</td>
                      <td>:</td>
                      <td>{order_info.zipcode || "NA"} </td>
                    </tr>
                  )}
                  {order_info.zone_type === "distance" && (
                    <tr>
                      <td>{I18n.t("general.distance")}</td>
                      <td>:</td>
                      <td>
                        {!isEmpty(order_info.distance)
                          ? `${parseFloat(order_info.distance).toFixed(2)} ${AppConfig.distance_unit
                          }`
                          : "NA"}{" "}
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td>{I18n.t("los.label")}</td>
                    <td>:</td>
                    <td>{order_info.level_of_service || "NA"}</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    ) : (
      <table width="100%" style={{ ...marginTop10 }} cellpadding="0px">
        <tbody>
          <tr>
            <td width="65%">
              <table width="100%">
                <tbody>
                  <tr>
                    <td style={{ ...shipperHeading, ...textBold }}>
                      <h3>{I18n.t("invoices.billed_to")}</h3>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ ...smallContent }}>
                      <h4>{data.name || "NA"}</h4>
                      <AddressInfo
                        address={(data && data.address) || {}}
                        showIcon
                        displayType="line"
                      />
                    </td>
                  </tr>
                  {!isEmpty(data.email) && (
                    <tr>
                      <td>
                        <Icon type="mail" /> &nbsp; {data.email}
                      </td>
                    </tr>
                  )}
                  {!isEmpty(data.contact) && (
                    <tr>
                      <td>
                        <Icon type="phone" /> &nbsp;{" "}
                        {formatUSPhoneNumber(data.contact)}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </td>
            <td width="35%" />
          </tr>
        </tbody>
      </table>
    );
  };

  renderReference = () => {
    const orderInfo = this.state.invoice.order_info || {};
    return (
      <Row>
        {(!isEmpty(orderInfo.mawb) || !isEmpty(orderInfo.hawb)) && (
          <Col xs={24}>
            <h4 style={{ marginBottom: 0, marginLeft: 9 }}>
              {I18n.t("order.reference_label")}
            </h4>
            {!isEmpty(orderInfo.mawb) && (
              <Row>
                <Col xs={24} style={{ marginLeft: 20, fontSize: 13 }}>
                  <span>{I18n.t("general.mawb")}&nbsp;&nbsp;:&nbsp;&nbsp;</span>
                  <span>
                    <span>{doFormate(orderInfo.mawb)}</span>
                  </span>
                </Col>
              </Row>
            )}
            {!isEmpty(orderInfo.hawb) && (
              <Row>
                <Col xs={24} style={{ marginLeft: 20, fontSize: 13 }}>
                  <span>{I18n.t("general.hawb")}&nbsp;&nbsp;:&nbsp;&nbsp;</span>
                  <span>
                    <span>{doFormate(orderInfo.hawb)}</span>
                  </span>
                </Col>
              </Row>
            )}
          </Col>
        )}
      </Row>
    );
  };

  renderDetails = () => {
    const orders_info = this.state.invoice?.orders_info
      ? this.state.invoice.orders_info
      : [];
    const account_details = this.state.invoice?.account_details
      ? this.state.invoice.account_details
      : {};
    const appointmentDate = this.props.order?.scheduled_start_datetime ? moment.utc(this.props.order.scheduled_start_datetime) : moment();

    const { isEstimateModalVisible, dataSource, estimateData, } = this.state;
    const { totalDistance, totalRate } = this.calculateTotals();
    const { customer_order_details } = this.props.order || {};
    const isLocked = customer_order_details?.is_locked === true || customer_order_details?.is_locked === "true";
    const canEdit = this.props.canEdit !== false;

    const columns = [
      {
        title: "Stop",
        dataIndex: "type_of_loc",
        key: "stop",
        width: 100,
        align: "left",
        render: (text, record) => {
         
          return (
            <div>
              {record.stop === "Pickup" ? (
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <PickupIconEstimate />  &nbsp; Pickup
                </span>
              ) : record.stop === "Delivery" ? (
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <DeliveryIconEstimate /> &nbsp; Delivery
                </span>
              ) : (
                record.stop
              )}
            </div>
          )
        },
      },
      {
        title: "Distance",
        dataIndex: "distance",
        key: "distance",
        width: 150,
        align: "center",
        render: (text, record) => (
          <Input
            value={text}
            onChange={(e) =>
              this.handleTableChange(e.target.value, record.location_id, "distance")
            }
            suffix="mi"
            className="table-input"
          />
        ),
      },
      {
        title: "Rate",
        dataIndex: "amount",
        key: "amount",
        width: 150,
        align: "center",
        render: (text, record) => (
          <Input
            value={text}
            prefix="$"
            onChange={(e) =>
              this.handleTableChange(e.target.value, record.location_id, "amount")
            }
            className="table-input"
          />
        ),
      },
      {
        title: "Includes Fuel",
        dataIndex: "include_fuel_surcharge",
        key: "include_fuel_surcharge",
        width: 100,
        align: "center",
        render: (checked, record) => (
          <Checkbox
            checked={checked}
            onChange={(e) =>
              this.handleTableChange(e.target.checked, record.location_id, "include_fuel_surcharge")
            }
          />
        ),
      },
    ];
    return (
      <Fragment>
        {checkServiceExistance("BLC") && this.state.callInvoceDetails && (
          <Fragment>
            <Row type='flex' justify='end' gutter={8}>
              {/* <Col>
                <Button className="small-btn flat" type="link" onClick={this.showEstimateModal}>
                  Edit Rates
                </Button>
              </Col> */}
              {/* <div style={{ width: '24px', display: 'inline-block' }} /> */}
              <Col>
                {canEdit && !this.props?.order?.is_deleted_order && <Button
                  data-testid="recalculate-button"
                  className="small-btn flat"
                  type="link"
                  size="small"
                  onClick={() =>
                    this.handleGenerateQuotation(this.state.order_id, true)
                  }
                  disabled={this.state.disableRecalculate || isLocked}
                >
                  {I18n.t("general.recalculate")}
                </Button>}
                {/* <RegenerationalConfirmationModal
                  onConfirm={(result) => {
                    // handleGenerateQuotation(id, generated_date);
                    // setModalVisible(false);
                    this.handleUpdateAmount(result)
                  }}
                  orderId={this.state.order_id}
                  showReloadIcon={false}
                  defaultDate={appointmentDate}
                  
            /> */}
              </Col>

              <Col>
                <Button_v2
                  data-testid="print-invoice-button"
                  // type="primary"
                  // className="button-large-estimate"
                  className="small-btn raised"
                  onClick={() => this.handlePrintBills(this.state.order_id)}
                  loading={this.state.printProgress}
                  style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                >
                  <PrintEstimateIcon />
                  {I18n.t("general.print")}
                </Button_v2>
              </Col>

              {/* <div style={{ width: '24px', display: 'inline-block' }} /> */}
              <Col>

                <Button_v2
                  data-testid="email-button"
                  // type="primary"
                  // className="button-large-estimate"
                  className="small-btn raised"
                  onClick={() => this.showEmailModal()}
                  style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                >
                  <SendEmailIcon />
                  {I18n.t("general.email")}
                </Button_v2>
              </Col>
            </Row>
            <Row className="account-details-row" data-testid="account-details-view">
              {account_details?.name && (
                // <Col md={24} className="marginTop10">
                //   {" "}
                //   <h5>
                //     Account: {account_details.name} ({account_details.code})
                //   </h5>
                // </Col>
                <>
                  <Col className="account-heading">Account</Col>
                  <Col className="account-details">{account_details.name}, {account_details.code}</Col>
                </>
              )}
            </Row>
            {!_.isEmpty(orders_info) && (
              <Row className="order-info-tab" data-testid="order-info-view">
                <Col md={24} className="smallContent marginTop10">
                  {orders_info?.length ? (
                    orders_info.map((zone, index) => (
                      <Row key={index} className={`order-info-row ${zone.is_combo ? "combo-info-row" : ""}`}>
                        {zone.is_combo ? (
                          <>
                            {/* Combo estimate header: Zip To Zip | Zone | LOS | Type | Distance */}
                            {zone.segment_type && (
                              <Col md={6} className="zone-details-col">
                                <Row>
                                  <Col md={24}>
                                    <div className="">
                                      <span className="zone-details">Zip To Zip:</span>
                                      <span className="zone-details-desc"> {`${zone.origin_zipcode || "NA"} → ${zone.destination_zipcode || "NA"}`}</span>
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                            )}
                            <Col md={5} className="zone-details-col">
                              <Row>
                                <Col md={24}>
                                  <div className="">
                                    <span className="zone-details-heading">Zone:</span>
                                    <span className="zone-details-desc">
                                      {zone.origin_zone_name && zone.destination_zone_name && zone.origin_zone_name !== zone.destination_zone_name
                                        ? `${zone.origin_zone_name} → ${zone.destination_zone_name}`
                                        : (zone.zone_name || zone.origin_zone_name || zone.destination_zone_name || "NA")}
                                    </span>
                                    {zone.fallback_note && (
                                      <div className="notes_content">{zone.fallback_note}</div>
                                    )}
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                            <Col md={3} className="zone-details-col">
                              <Row>
                                <Col md={24}>
                                  <div className="">
                                    <span className="zone-details-heading">{I18n.t("general.short_los")}:</span>
                                    <span className="zone-details-desc"> {zone.level_of_service || "NA"}</span>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                            <Col md={5} className="zone-details-col">
                              <Row>
                                <Col md={24}>
                                  <div className="">
                                    <span className="zone-details-heading">Type:</span>
                                    <span className="zone-details-desc">{this.getZoneType(zone.zone_type) || "NA"}</span>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                            {/* Billing weight is order-level, so the consolidated combo row
                                shows the same weight the per-leg rows show (non-combo branch). */}
                            <Col md={5} className="zone-details-col">
                              <Row>
                                <Col md={24}>
                                  <div className="">
                                    <span className="zone-details-heading">Weight:</span>
                                    <span className="zone-details-desc">
                                      {!isEmpty(zone.weight)
                                        ? `${zone.weight} ${zone.weight_units}`
                                        : "NA"}
                                    </span>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                            <Col md={4} className="zone-details-col">
                              <Row>
                                <Col md={24}>
                                  <div className="">
                                    <span className="zone-details-heading">{I18n.t("general.distance")}:</span>
                                    <span className="zone-details-desc">
                                      {" "}
                                      {/* 0 is a real distance (org considers order mileage and the
                                          location has none) — show it like the non-combo rows do
                                          instead of hiding it behind a dash. */}
                                      {!isEmpty(zone.distance)
                                        ? `${parseFloat(zone.distance)} ${AppConfig.distance_unit}`
                                        : "-"}
                                    </span>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </>
                        ) : (
                          <>
                            {zone.segment_type && (
                              <Col md={3} className="zone-details">
                                {zone.segment_type ? `${zone.segment_type} ` : ""}
                              </Col>
                            )}

                            <Col md={5} className="zone-details-col">
                              <Row>
                                <Col md={24}>
                                  <div className="">
                                    <span className="zone-details-heading">
                                      {/* {" "}
                                      <Icon type="account-book" />
                                      &nbsp;
                                      {I18n.t("zones.zonename")}&nbsp;:&nbsp; */}
                                      Zone:
                                    </span>
                                    <span className="zone-details-desc">{zone.zone_name || "NA"}</span>
                                    {zone.fallback_note && (
                                      <div className="notes_content">{zone.fallback_note}</div>
                                    )}
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                            <Col md={5} className="zone-details-col">
                              <Row>
                                <Col md={24}>
                                  <div className="">
                                    <span className="zone-details-heading">
                                      {/* {" "}
                                      <Icon type="account-book" />
                                      &nbsp;
                                      {I18n.t("zones.type")}&nbsp;:&nbsp; */}
                                      Type:
                                    </span>
                                    <span className="zone-details-desc">{this.getZoneType(zone.zone_type) || "NA"}</span>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                            <Col md={5} className="zone-details-col">
                              <Row>
                                <Col md={24}>
                                  <div className="">
                                    <span className="zone-details-heading">
                                      Weight:
                                    </span>
                                    <span className="zone-details-desc">
                                    {!isEmpty(zone.weight)
                                      ? `${zone.weight} ${zone.weight_units}`
                                      : "NA"}
                                  </span>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                            {["location","city-zipcode"].includes(zone.zone_type) && (
                              <>
                                <Col md={5} className="zone-details-col">
                                  <Row>
                                    <Col md={24}>
                                      <div className="textBold">
                                        <span className="zone-details-heading">
                                          {/* {" "}
                                          <Icon type="environment" />
                                          &nbsp; */}
                                          {I18n.t("general.zipcode")}:
                                        </span>
                                        <span className="zone-details-desc">{zone?.zipcode || "NA"}</span>
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                                {/* )} */}

                                <Col md={8} className="zone-details-col">
                                  <Row>
                                    <Col md={24}>
                                      <div className="">
                                        <span className="zone-details-heading">
                                          {/* <BranchesIcon />
                                          &nbsp; */}
                                          {I18n.t("general.distance")}:
                                        </span>
                                        <span className="zone-details-desc">
                                          {" "}
                                          {!isEmpty(zone.distance)
                                            ? `${parseFloat(zone.distance)} ${AppConfig.distance_unit
                                            }`
                                            : "NA"}
                                        </span>
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                              </>
                            )}
                            {zone.zone_type === "distance" && (
                              <Col md={8} className="zone-details-col">
                                <Row>
                                  <Col md={24}>
                                    <div className="">
                                      <span className="zone-details-heading">
                                        {/* <BranchesIcon />
                                        &nbsp; */}
                                        {I18n.t("general.distance")}:
                                      </span>
                                      <span className="zone-details-desc">
                                        {" "}
                                        {!isEmpty(zone.distance)
                                          ? `${parseFloat(zone.distance)} ${AppConfig.distance_unit
                                          }`
                                          : "NA"}
                                      </span>
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                            )}
                          </>
                        )}
                      </Row>
                    ))
                  ) : (
                    <Fragment />
                  )}
                </Col>
              </Row>
            )}
          </Fragment>
        )}
        {this.state.invoice?.is_prepaid === true && (
          <Row className="prepaid-amount-banner-row">
            <Col span={24}>
              <PrepaidAmountWithPreview
                amount={this.state.invoice.prepaid_amount}
                cashReceiptLegs={this.state.invoice.cash_receipt_pictures}
              />
            </Col>
          </Row>
        )}
        {this.state.currentOrderGroupType !== "TEMPLATE" &&
          this.state.chargeTypes
            .filter(
              (sectionType) =>
                this.state.invoice[sectionType] &&
                this.state.invoice[sectionType].length > 0
            )
            .map((sectionType) => {
              const order_references = this.state?.order_references
                ? this.state.order_references
                : {};
              const orderObj =
                _.find(this.state.invoice.transportation_charges, {
                  order_id: this.state.order_id,
                }) || {};
              // Transfer/PLHD orders (type_of_order 'T') keep the linehaul segment's
              // LOS only in all_locations — the plain `locations` list omits it. Use
              // all_locations for them so the header shows "Linehaul LOS" alongside
              // Pickup/Delivery. Pure LH orders already carry the linehaul row in
              // `locations`, and multi-stop stays on `locations` (its all_ms_locations
              // has no LOS codes) — so only transfer orders switch source.
              const headerLocations =
                orderObj?.type_of_order === "T" && orderObj?.all_locations
                  ? orderObj.all_locations
                  : orderObj?.locations;
              const locations =
                sectionType === "transportation_charges" && headerLocations
                  ? headerLocations
                  : [];
              return (
                <div className="charges-table-view" data-testid={`${sectionType}-view`}>
                  <Row type="flex" justify='space-between' align="center" className="charge-details-row">
                    <Col className="section-type">
                      {/* <h5> */}
                      {I18n.t(`invoices.${sectionType}`)}
                      {/* {sectionType === "transportation_charges"
                          ? this.state.invoice.transportation_gl_code
                            ? ` ( ${I18n.t("invoices.gl_code")} : ${
                                this.state.invoice.transportation_gl_code
                              } )`
                            : ""
                          : ""} */}
                      {/* </h5> */}
                    </Col>

                    <Col>
                      <Row type='flex' gutter={24}>
                        <Col className="charge-details-desc">
                          {sectionType === "transportation_charges"
                            ? this.state.invoice.transportation_gl_code
                              ?
                              <>
                                <span className="charge-desc-head">{`${I18n.t("invoices.gl_code")}:`}</span>
                                <span className="charge-desc-details">{this.state.invoice.transportation_gl_code}</span>
                              </>
                              : ""
                            : ""}
                        </Col>

                        {/* {this.state.invoice.order_info.level_of_service} */}
                        {sectionType === "transportation_charges"
                          ? locations.map((loc) => (
                            <Col className="charge-details-desc">
                              {/* <h5> */}
                              <span className="charge-desc-head">
                                {loc.order_type ? (
                                  <span className="textCaptilize">
                                    {_.lowerCase(loc.order_type)}
                                  </span>
                                ) : (
                                  ""
                                )}{" "}
                                {I18n.t("general.short_los")} :
                              </span>
                              <span className="charge-desc-details">{loc.level_of_service_code || "NONE"}</span>
                              {/* </h5> */}
                            </Col>
                          ))
                          : ""}
                      </Row>
                    </Col>
                  </Row>
                  {/* {sectionType === "adjustment_charges" && (
                    <ManageInvoiceLine
                      mode="add"
                      data={null}
                      // location_id
                      order_id={this.state.order_id}
                    
                    />
                  )} */}
                  <table
                    // border="1px"
                    cellpadding="5px"
                    cellspacing="0px"
                    width="100%"
                    style={{ ...borderCollapseInherit }}
                    className="charge-details-table"
                  >
                    <tbody>
                      <tr>
                        <td width="32px" className="table-heading">
                          #
                        </td>
                        <td width="245px" className="table-heading">
                          {I18n.t("general.description")}
                        </td>
                        <td width="148px" className="table-heading alignRight">
                          {I18n.t("invoices.units")}
                        </td>
                        <td width="148px" className="table-heading alignRight">
                          {I18n.t("invoices.amount")}
                        </td>
                      </tr>
                      {this.state.invoice[sectionType].map((order, index) => {
                        // for not showing zero values in adjustments
                        // const priceList = !isEmpty(order.price_list)
                        //   ? sectionType === "adjustment_charges"
                        //     ? order.price_list.filter(
                        //       (item) => item.invoice_value// > 0
                        //     )
                        //     : [...order.price_list]
                        //   : [];
                        const priceList = !isEmpty(order.price_list) ?  [...order.price_list] : [] ;
                        return priceList.length > 0 ? (
                          <Fragment>
                            <tr>
                              <td
                                className="tbody-item-head"
                                // style={{ ...invoiceItem, ...alignCenter }}
                              >
                                {index + 1}
                              </td>
                              <td 
                                className="tbody-item-head"
                                // style={{ ...invoiceItem, ...textBold }}
                              >
                                #{order.order_number}&nbsp;
                                {order_references[order.order_number] && (
                                  <HawbMawbNo
                                    record={
                                      order_references[order.order_number]
                                    }
                                  />
                                )}
                              </td>
                              <td 
                                className="tbody-item-head"
                                // style={{ ...invoiceItem }}
                              >&nbsp;</td>
                              <td 
                                className="tbody-item-head"
                                // style={{ ...invoiceItem, ...alignRight }}
                              >
                                &nbsp;
                              </td>
                            </tr>

                            {priceList // filter(invoiceItem => invoiceItem.invoice_value !== 0)
                              .map((item, itemIndex) => {
                                const rowSpan = findSpanValue(
                                  priceList,
                                  item,
                                  itemIndex
                                );
                                return (
                                  <tr>
                                    <td
                                      className="tbody-item-body"
                                      // style={{ ...invoiceItem, ...alignCenter }}
                                    >
                                      {/* {sectionType === "adjustment_charges"
                                ? itemIndex + 1
                                : ""} */}
                                    </td>
                                    <td
                                      className="tbody-item-body"
                                      // style={{ ...invoiceItem }}
                                    >
                                      {item.invoice_name}{" "}
                                      {item.item_description ? (
                                        <i style={{ ...fontSize10 }}>
                                          {" "}
                                          {item.item_description}{" "}
                                        </i>
                                      ) : (
                                        ""
                                      )}
                                      {item.added_from === "MANUAL" && (
                                        <sup className="textRed textBold">
                                          M
                                        </sup>
                                      )}
                                      {(item?.added_from_quote || false) && (
                                        <sup className="textRed textBold">
                                          Q
                                        </sup>
                                      )}
                                    </td>
                                    {rowSpan !== 0 && (
                                      <td
                                        className="tbody-item-body alignRight"
                                        // style={{ ...invoiceItem }}
                                        rowSpan={rowSpan}
                                      >
                                        {rowSpan === 1 ? (
                                          !isEmpty(item.invoice_quantity) &&
                                            item.invoice_quantity !== 0 ? (
                                            item.invoice_quantity
                                          ) : (
                                            <Fragment>&nbsp;</Fragment>
                                          )
                                        ) : (
                                          rowSpan
                                        )}
                                      </td>
                                    )}
                                    {rowSpan !== 0 && (
                                      <td
                                        className="tbody-item-body alignRight"
                                        // style={{
                                        //   ...invoiceItem,
                                        //   ...alignRight,
                                        // }}
                                        rowSpan={rowSpan}
                                      >
                                        {checkNegitive(item.invoice_value)}
                                      </td>
                                    )}
                                  </tr>
                                );
                              })}
                          </Fragment>
                        ) : (
                          <Fragment />
                        );
                      })}
                    </tbody>
                  </table>

                  <table width="100%" className="invoice-amount-table">
                    <tbody>
                      <tr>
                        <td width="277px" 
                          className="invoice-sub-total"
                          // style={{ ...marginTop40 }} 
                        />
                        <td width="296px" style={{padding: 0}}>
                          <table width="100%">
                            <tbody>
                              <tr>
                                <td
                                  width="148px"
                                  className="invoice-sub-total alignRight"
                                  // style={{ ...alignRight, ...totalItems }}
                                >
                                  {I18n.t("invoices.sub_total")}
                                </td>
                                <td
                                  width="148px"
                                  className="invoice-sub-total alignRight"
                                  // style={{ ...alignRight, ...totalItems, ...textBold }}
                                >
                                  {this.findSectionTotal(sectionType)}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              );
            })}
        {this.state.currentOrderGroupType === "TEMPLATE" && (
          <div style={{ ...borderLine, ...marginTop20, ...padding5 }}>
            <Row type="flex" gutter={32}>
              <Col>
                <h5>Charges</h5>
              </Col>
            </Row>
            <table
              border="1px"
              cellPadding="5px"
              cellSpacing="0px"
              width="100%"
              style={{ ...borderCollapseInherit }}
              data-testid="charges-view"
            >
              <tbody>
                <tr>
                  <td width="4%" style={{ ...heading, ...alignCenter }}>
                    #
                  </td>
                  <td width="58%" className="heading">
                    {I18n.t("general.description")}
                  </td>
                  <td width="16%" className="heading">
                    {I18n.t("invoices.units")}
                  </td>
                  <td width="22%" className="heading alignRight">
                    {I18n.t("invoices.amount")}
                  </td>
                </tr>
                {this.state.invoice.transportation_charges.map(
                  (order, index) => {
                    const priceList = !isEmpty(order.price_list)
                      ? order.price_list
                      : [];
                    return priceList.length > 0 ? (
                      <Fragment key={order.order_number}>
                        <tr>
                          <td style={{ ...invoiceItem, ...alignCenter }}>
                            {index + 1}
                          </td>
                          <td style={{ ...invoiceItem, ...textBold }}>
                            #{order.order_number}&nbsp;
                            {this.state?.order_references?.[
                              order.order_number
                            ] && (
                                <HawbMawbNo
                                  record={
                                    this.state.order_references[
                                    order.order_number
                                    ]
                                  }
                                />
                              )}
                          </td>
                          <td style={{ ...invoiceItem }}>&nbsp;</td>
                          <td style={{ ...invoiceItem, ...alignRight }}>
                            &nbsp;
                          </td>
                        </tr>
                        {priceList.map((item, itemIndex) => {
                          const rowSpan = findSpanValue(
                            priceList,
                            item,
                            itemIndex
                          );
                          return (
                            <tr key={itemIndex}>
                              <td style={{ ...invoiceItem, ...alignCenter }} />
                              <td style={{ ...invoiceItem }}>
                                {item.invoice_name}{" "}
                                {item.item_description && (
                                  <i style={{ ...fontSize10 }}>
                                    {" "}
                                    {item.item_description}{" "}
                                  </i>
                                )}
                                {item.added_from === "MANUAL" && (
                                  <sup className="textRed textBold">M</sup>
                                )}
                                {(item?.added_from_quote || false) && (
                                  <sup className="textRed textBold">Q</sup>
                                )}
                              </td>
                              {rowSpan !== 0 && (
                                <td
                                  style={{ ...invoiceItem }}
                                  rowSpan={rowSpan}
                                >
                                  {rowSpan === 1 ? (
                                    !isEmpty(item.invoice_quantity) &&
                                      item.invoice_quantity !== 0 ? (
                                      item.invoice_quantity
                                    ) : (
                                      <Fragment>&nbsp;</Fragment>
                                    )
                                  ) : (
                                    rowSpan
                                  )}
                                </td>
                              )}
                              {rowSpan !== 0 && (
                                <td
                                  style={{ ...invoiceItem, ...alignRight }}
                                  rowSpan={rowSpan}
                                >
                                  {checkNegitive(item.invoice_value)}
                                </td>
                              )}
                            </tr>
                          );
                        })}
                      </Fragment>
                    ) : (
                      <Fragment key={order.order_number} />
                    );
                  }
                )}
              </tbody>
            </table>
            <table width="100%" style={{ ...marginTop20 }} data-testid="sub-total-view">
              <tbody>
                <tr>
                  <td width="62.5%" style={{ ...marginTop40 }} />
                  <td width="37.5%">
                    <table width="100%">
                      <tbody>
                        <tr>
                          <td
                            width="42%"
                            style={{ ...alignRight, ...totalItems }}
                          >
                            {I18n.t("invoices.sub_total")}
                          </td>
                          <td
                            width="58%"
                            style={{
                              ...alignRight,
                              ...totalItems,
                              ...textBold,
                            }}
                          >
                            {this.findSectionTotal("transportation_charges")}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
        <table width="100%" className="total-amount-section" data-testid="total-amount-view">
          <tbody>
            <tr>
              <td width="277px" style={{ ...marginTop40 }}>
                {this.state.showOtherDetails && this.renderComments()}
              </td>
              <td width="296px" style={{padding: 0}}>
                <table width="100%">
                  <tbody>
                    {false && (
                      <tr>
                        <td
                          width="42%"
                          style={{ ...alignRight, ...totalItems }}
                        >
                          {I18n.t("invoices.sub_total")}
                        </td>
                        <td
                          width="58%"
                          style={{ ...alignRight, ...totalItems, ...textBold }}
                        >
                          {this.state.currentOrderGroupType !== "TEMPLATE"
                            ? this.state.invoice.sub_total
                              ? checkNegitive(this.state.invoice.sub_total)
                              : checkNegitive(this.state.invoice.total_amount)
                            : ""}
                          {this.state.currentOrderGroupType === "TEMPLATE" &&
                            this.findSectionTotal("transportation_charges")}
                        </td>
                      </tr>
                    )}
                    <tr>
                      <td
                        width="148px" 
                        className="taxable-row alignRight"
                        // style={{ ...alignRight, ...totalItems }}
                      >
                        {I18n.t("invoices.taxable")}
                      </td>
                      <td
                        width="148px"
                        className="taxable-row alignRight"
                        // style={{ ...alignRight, ...totalItems, ...textBold }}
                      >
                        {checkNegitive(this.state.invoice.taxable)}
                      </td>
                    </tr>
                    <tr>
                      <td
                        width="148px"
                        className="total-amount alignRight"
                        // style={{ ...alignRight, ...totalItems, ...textBold }}
                      >
                        {I18n.t("invoices.total")}
                      </td>
                      <td
                        width="148px"
                        className="total-amount alignRight"
                        // style={{ ...alignRight, ...totalItems, ...textBold }}
                      >
                        {checkNegitive(this.state.invoice.total_amount)}
                      </td>
                    </tr>
                    {/* <tr>
                      <td colspan="2" style={{ height: 85 }} />
                    </tr> */}
                    {this.state.showOtherDetails && (
                      <tr>
                        <td
                          colspan="2"
                          style={{
                            ...alignCenter,
                            ...textBold,
                            ...totalItems,
                          }}
                        >
                          [{" "}
                          {this.state.invoice.organization_name ||
                            "Company Name"}{" "}
                          ]
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
        {this.state.showEmailModal && this.renderEmailModal()}
        <EditEstimateModal
        isModalVisible={isEstimateModalVisible}
        handleCancel={this.handleEstimateModalCancel}
        dataSource={estimateData}
        existingData={dataSource}
        orderid = {this.state.order_id}
        currentOrg = {this.props.currentOrg}
        recalculate = {this.handleGenerateQuotation}
        currenOrder={this.props.order}
      />
      </Fragment>
    );
  };
  renderSignatutes = () => {
    const podPics = this.state.invoice.pod_pictures
      ? this.state.invoice.pod_pictures
      : [];
    const signaturePics = [];
    podPics.forEach((picData) => {
      if (picData.pictures) {
        const signs = picData.pictures
          .filter(
            (pic) =>
              pic.image_type === "signature" && pic.picture && pic.picture.url
          )
          .map((pic) => {
            return { url: pic.picture.url, sign_by: pic.sign_by };
          });
        if (signs.length > 0) {
          signaturePics.push({
            sign: signs[0].url,
            order_number: picData.customer_order_number,
            sign_by: signs[0].sign_by,
          });
        }
      }
    });
    return (
      <Fragment>
        {signaturePics.map((pic, index) =>
          index === 0 ? (
            <div
              class="textCenter"
              style={{
                width: "100%",
                ...floatLeft,
                ...borderLine,
                ...padding5,
                ...marginTop10,
                ...marginLeft10,
              }}
            >
              <div>
                <img src={pic.sign} alt="sign" style={{ width: "100%" }} />
              </div>
              <div style={{ ...alignCenter, ...textBold }}>
                Sign By: {pic.sign_by}
              </div>
            </div>
          ) : null
        )}
      </Fragment>
    );
  };

  renderPodPictures = () => {
    const podPics = this.state.invoice.pod_pictures
      ? this.state.invoice.pod_pictures
      : [];
    const normalPics = [];
    podPics.forEach((picData) => {
      if (picData.pictures) {
        const signs = picData.pictures
          .filter(
            (pic) =>
              pic.image_type === "normal" && pic.picture && pic.picture.url
          )
          .map((pic) => {
            return { url: pic.picture.url, pic_title: pic.pic_title };
          });
        if (signs.length > 0) {
          normalPics.push({
            sign: signs[0].url,
            order_number: picData.customer_order_number,
          });
        }
      }
    });
    return (
      <Fragment>
        {normalPics.map((pic, index) => (
          <div
            class="textCenter"
            style={{
              width: "100%",
              ...floatLeft,
              ...borderLine,
              ...padding5,
              ...marginTop10,
              ...marginLeft10,
            }}
            key={`image${index}`}
          >
            <div>
              <img src={pic.sign} alt="PIC" style={{ width: "100%" }} />
            </div>
            <div style={{ ...alignCenter }}>Order No: #{pic.order_number}</div>
          </div>
        ))}

      </Fragment>
    );
  };

  _renderInvoce = () => {
    return (
      <Spin spinning={this.state.inProgress} delay={1000}>
        {this.state.showHeading && this.renderWHDetails()}
        {this.state.showOtherDetails && this.renderShipperDetails()}
        {false && this.renderReference()}
        {this.renderDetails()}
        {this.state.showOtherDetails && (
          <Fragment>
            {this.renderPodPictures()}
            {this.renderSignatutes()}
            <Row>
              <Col
                xs={24}
                className="alignCenter smallText marginTop40 fontSize15"
              >
                For all terms & conditions please refer{" "}
                <a href="https://fleetenable.com/">
                  <u className="text-decoration-dashed">here</u>
                </a>
              </Col>
            </Row>
          </Fragment>
        )}
      </Spin>
    );
  };

  render() {
    const { account } = this.state;
    return (
      <div className="invoice-box">
        <this._renderInvoce />
      </div>
    );
  }
}

export const Form = withRouter((props) => {
  const { orgSettings: organizationSettings, currentOrg } = useContext(OrgContext);
  return <FormComponent {...props} organizationSettings={organizationSettings} currentOrg={currentOrg} />;
});

export default Form;